// extracted by mini-css-extract-plugin
module.exports = {"cardTemp":"CardTemp_cardTemp__1vMrH"};